import type { ReactNode } from "react";
import { useAccount } from "wagmi";
import { GameProvider } from "@looksrare/uikit";
import { ChainId } from "@looksrare/config";
import { QuantumConfig } from "@looksrare/classic-games/quantum";
import { isBefore } from "date-fns/isBefore";
import { gameAddresses } from "@/config";
import { useGlobalSettings } from "@/hooks";
import { useUser } from "@/queries/user";

export const YoloGamesQuantumProvider = ({ children }: { children: ReactNode }) => {
  const isSoundEnabled = useGlobalSettings((state) => state.isSoundEnabled);
  const { address } = useAccount();
  const { data: user } = useUser(address!, { enabled: !!address });

  return (
    <GameProvider<QuantumConfig>
      widgetBotOptions={{
        server: "1204359490925764680",
        channel: "1247424825346097152",
        shard: "https://emerald.widgetbot.io",
        glyph: ["/images/win/chat.png", "32px"],
        color: "#CCFD07",
        notifications: false,
        indicator: true,
      }}
      supportedNetworks={["blast"]}
      addresses={gameAddresses}
      fallbackChainId={ChainId.BLAST_MAINNET}
      config={{
        isMuted: !isSoundEnabled,
        supportedCurrencies: ["ETH", "YOLO"],
        selfTimeoutUntil: user?.selfTimeoutUntil,
        isWalletBlocked: !!user?.selfTimeoutUntil && isBefore(Date.now(), user?.selfTimeoutUntil),
        points: {
          enabled: false,
        },
      }}
    >
      {children}
    </GameProvider>
  );
};
